function wrapEvents(...handlers) {
  return event => {
    handlers.some(fn => {
      if (fn) {
        fn(event);
      }

      return event.defaultPrevented;
    });
    return undefined;
  };
}

export { wrapEvents };